import { ParamTypes } from 'global-services/register/OhsRegisterModels';
import { getSortOptions, SortOptionKey } from 'global-services/register/OhsSortModels';
import { returnHasFilter } from 'global-services/register/utils';
import { safeJSONParse } from 'global-services/utils/OhsUtility';
import {
  OhsAvailableInspectionFilterPayload,
  OhsAvailableInspectionMain,
} from 'inspection/OhsInspectionModels';

export const sortOptions = getSortOptions([SortOptionKey.TitleAToZ, SortOptionKey.TitleZToA]);

export const sortSearchOptions = getSortOptions([
  SortOptionKey.Relevance,
  SortOptionKey.TitleAToZ,
  SortOptionKey.TitleZToA,
  SortOptionKey.CategoryAToZ,
  SortOptionKey.CategoryZToA,
  SortOptionKey.SubCategoryAToZ,
  SortOptionKey.SubCategoryZToA,
]);

export interface AvailableInspectionSearchFilterForm {
  sort: any;
  hasSearch: boolean;
  searchKey: string;
  substringSearch: boolean;
  page: number;
  next?: string;
}

export default class OhsAvailableInspectionFilterModels {
  hasFilter: boolean;

  hasSearch: boolean;

  searchKey: string;

  page: number;

  filter: OhsAvailableInspectionFilterPayload;

  filterCount: OhsAvailableInspectionFilterPayload;

  searchFilter: OhsAvailableInspectionMain;

  searchFilterCount: OhsAvailableInspectionMain;

  buildFilters: (payload: number | any, next?: string) => any;

  constructor(formFilter: AvailableInspectionSearchFilterForm) {
    const defaultFilter = { sort: JSON.parse(sortOptions[0].value) };

    const {
      sort,
      hasSearch,
      searchKey,
      substringSearch,

      page,
      next,
    } = formFilter;

    const inspectionFilters = {
      ...(next && page > 10 ? { next } : { page }),
      count: false,
    };
    const countFilters = { count: true };

    // ============ Params ============
    this.hasSearch = hasSearch;
    this.searchKey = searchKey;
    this.page = page;

    // ============ Filter Objs ============

    const validSort = sortOptions.find((item) => item.value === JSON.stringify(sort));

    this.filter = {
      ...inspectionFilters,
      sort: validSort ? sort : JSON.parse(sortOptions[0].value),
    };
    this.filterCount = {
      ...countFilters,
      sort: validSort ? sort : JSON.parse(sortOptions[0].value),
    };

    const validSearchSort = sortSearchOptions.find((item) => item.value === JSON.stringify(sort));

    this.searchFilter = {
      searchKey,
      substringSearch,
      highlight: false,
      sort: validSearchSort ? sort : JSON.parse(sortSearchOptions[0].value),
      filter: inspectionFilters,
    };

    this.searchFilterCount = {
      searchKey,
      substringSearch,
      highlight: false,
      sort: validSearchSort ? sort : JSON.parse(sortSearchOptions[0].value),
      filter: countFilters,
    };

    this.hasFilter = returnHasFilter(defaultFilter, this.filter);

    // ============ Funcs ============
    this.buildFilters = (payload: number | any, nextId?: string) => {
      let newPayload: any = {};

      if (typeof payload === 'number') {
        if (hasSearch) {
          newPayload = this.searchFilter;
          newPayload[ParamTypes.Page] = payload;
        } else {
          newPayload = this.filter;
          newPayload[ParamTypes.Page] = payload;
        }
        if (payload > 10) newPayload[ParamTypes.Next] = nextId;
      } else {
        newPayload = {
          ...payload,
          [ParamTypes.Page]: 1,
          [ParamTypes.Next]: undefined,
        };
      }

      newPayload = {
        ...newPayload,
        sort: typeof payload.sort === 'string' ? safeJSONParse(payload.sort) : payload.sort,
        hasSearch: !!newPayload?.searchKey,
      };
      return newPayload;
    };
  }
}
